import { observable, computed, action } from "mobx";

class ScreenfullImpl {

	private methods: { [key: string]: string } = { "": "" };
	private keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;

	readonly enabled: boolean;
	@observable element: HTMLElement = null;

	constructor() {
		this.init();
		this.enabled = this.isFullscreenEnabled();
		this.element = this.getFullscreenElement();
	}

	private init() {

		const fnMap = [
			[
				'requestFullscreen',
				'exitFullscreen',
				'fullscreenElement',
				'fullscreenEnabled',
				'fullscreenchange',
				'fullscreenerror'
			],
			// New WebKit
			[
				'webkitRequestFullscreen',
				'webkitExitFullscreen',
				'webkitFullscreenElement',
				'webkitFullscreenEnabled',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			// Old WebKit (Safari 5.1)
			[
				'webkitRequestFullScreen',
				'webkitCancelFullScreen',
				'webkitCurrentFullScreenElement',
				'webkitCancelFullScreen',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			[
				'mozRequestFullScreen',
				'mozCancelFullScreen',
				'mozFullScreenElement',
				'mozFullScreenEnabled',
				'mozfullscreenchange',
				'mozfullscreenerror'
			],
			[
				'msRequestFullscreen',
				'msExitFullscreen',
				'msFullscreenElement',
				'msFullscreenEnabled',
				'MSFullscreenChange',
				'MSFullscreenError'
			]
		];
		let i = 0;
		let l = fnMap.length;
		let val;

		for (; i < l; i++) {
			val = fnMap[i];
			if (val && val[1] in document) {
				for (i = 0; i < val.length; i++) {
					this.methods[fnMap[0][i]] = val[i];
				}
				break;
			}
		}

		this.onFullscreenChange(() => { this.element = this.getFullscreenElement() });
	}

	request(elem: HTMLElement) {
		if (elem == null) {
			elem = document.documentElement;
		}
		const request = this.methods["requestFullscreen"];
		// Work around Safari 5.1 bug: reports support for
		// keyboard in fullscreen even though it doesn't.
		// Browser sniffing, since the alternative with
		// setTimeout is even worse.
		if (/5\.1[.\d]* Safari/.test(navigator.userAgent) || this.getChromeVersion() >= 71) {
			(<any>elem)[request]();
		}
		else {
			(<any>elem)[request](this.keyboardAllowed);// && Element.ALLOW_KEYBOARD_INPUT);
		}
	}

	getChromeVersion() {
		var raw = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
		return raw ? parseInt(raw[2], 10) : 0;
	}

	exit() {
		(<any>document)[this.methods["exitFullscreen"]]();
	}

	toggle(elem: HTMLElement): boolean {
		const oldElem = this.getFullscreenElement();
		if (oldElem == null) {
			this.request(elem);
			return true;
		}
		else {
			this.exit();
			return false;
		}
	}

	private isFullscreenEnabled(): boolean {
		return Boolean((<any>document)[this.methods.fullscreenEnabled]);
	}

	private onFullscreenChange(callback: any) {
		document.addEventListener(this.methods["fullscreenchange"], callback, false);
	}

	private onFullscreenError(callback: any) {
		document.addEventListener(this.methods["fullscreenerror"], callback, false);
	}

	private getFullscreenElement(): HTMLElement {
		return (<any>document)[this.methods["fullscreenElement"]] as HTMLElement;
	}

}


export const Screenfull = new ScreenfullImpl();